module.exports = __webpack_public_path__ + "static/media/banco.3cd2c9de.svg";